'use client';

import React, { useEffect } from 'react';
import NextError from 'next/error';
import { captureSentryException, CaptureParams, SentryContext } from '../utils/sentry';

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    const paramsForUtil: CaptureParams = { error };
    const contextForUtil: SentryContext = {};

    captureSentryException(paramsForUtil, contextForUtil);
  }, [error]);

  return (
    <html>
      <body>
        {/* Using a generic 500 status code for NextError page */}
        <NextError statusCode={500} />
      </body>
    </html>
  );
}
